// Dashboards route — the default landing page.
// -----------------------------------------------------------------
// Dashboard is the operator's home screen: live tour overview +
// on-demand health checks + orphan detection. No feature flag gate
// — always rendered for authenticated admins. The root / redirect
// points here (src/routes/index.tsx).

import { createFileRoute } from '@tanstack/react-router';

import { DashboardsPage } from '@/components/dashboards/DashboardsPage';

const DashboardsRoute = () => <DashboardsPage />;

export const Route = createFileRoute('/_authenticated/dashboards')({
  component: DashboardsRoute,
});
